import React from 'react';
import {get, lowerCase} from "lodash";
import moment from 'moment';
import {Col, Row} from "antd";
import DefaultPropsInterface from "../../../Interface/DefaultPropsInterface";
import Utils from '../../../Util/Utils';
import PaymentVoucherDomain, {PaymentVoucherModel} from "../../../Domain/PaymentVoucherDomain";
import PaymentVoucherApi from "../../../Api/PaymentVoucherApi";
import QrCode from "../../../Component/QrCode";
import Barcode from "../../../Component/Barcode";
import { NotificationCommon } from '../../../Component/Notification';

interface Props extends DefaultPropsInterface {

}

interface State {
    paymentVoucher: PaymentVoucherDomain | null,
    loading: boolean,
    qrCodeDataImg: string,
    barcodeDataImg: string
}

class PaymentVoucherPrint extends React.Component<Props, State> {

    state = {
        paymentVoucher: {...PaymentVoucherModel},
        loading: false,
        qrCodeDataImg: "",
        barcodeDataImg: ""
    }

    componentDidMount() {
        this.fetchPaymentVoucher();
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('print-layout');
        body.classList.add('A4');
        body.classList.add('landscape');

        setTimeout(() => {
            window.print();
        }, 600);

        window.onfocus = function () {
            window.close();
        }
    }

    getCode = () => {
        return this.props.match.params.code;
    }

    fetchPaymentVoucher = () => {
        this.setState({loading: true});
        PaymentVoucherApi.getByCode(this.getCode())
            .then(response => {
                this.setState({
                    paymentVoucher: response.data
                });
            })
            .catch((err) => {
                if (get(err, 'response.status') === 404) {
                    NotificationCommon.error({message: "Không tìm thấy phiếu chi!"})
				}
				else {
					NotificationCommon.error({
						message: 'Lỗi: ' + err.message
					})
				}
            })
            .finally(() => {
                this.setState({loading: false});
            })
    }

    render() {
        const {paymentVoucher} = this.state;
        const currency = get(paymentVoucher, 'currency.code');
        const currencyName = get(paymentVoucher, 'currency.name');
        const clones = [0, 1];
        return (
            <>
                {clones.map(clone => (
                    <div className="main-content sheet">
                        <div className="mg-t-20 mg-bt-20 mg-r-20 mg-l-20">
                            <div className="voucher-header text-center">
                                PHIẾU {paymentVoucher.code}
                            </div>
                            <div className="voucher-body">
                                <div className={'text-center bold voucher-title'}>PHIẾU CHI</div>
                                <div
                                    className={'text-center italic voucher-date'}>(Ngày {moment(paymentVoucher.timestamp).format("DD")} Tháng {moment(paymentVoucher.timestamp).format("MM")} Năm {moment(paymentVoucher.timestamp).format("YYYY")})
                                </div>
                                <div className={'text-right lien-luu'}>Liên 0{clone + 1}: {clone === 0 ? 'Lưu' : 'Khách'}</div>
                                <Row gutter={20} className={'mg-t-30'}>
                                    <Col span={14}>
                                        <div className="detail-item">
                                            <div className={'detail-item--label'}>Người nhận:</div>
                                            <div className={'detail-item--value'}>{paymentVoucher.receiver}</div>
                                        </div>
                                        <div className="detail-item">
                                            <div className={'detail-item--label'}>Nội dung giao dịch:</div>
                                            <div className={'detail-item--value'}>{paymentVoucher.memo}</div>
                                        </div>
                                        <div className="detail-item">
                                            <div className={'detail-item--label'}>Số tiền:</div>
                                            <div
                                                className={'detail-item--value'}>{Utils.currencyFormatByCurrency(paymentVoucher.amount, currency)} {currency}</div>
                                        </div>
                                        <div className="detail-item">
                                            <div className={'detail-item--label'}>(Viết bằng chữ):</div>
                                            <div
                                                className={'detail-item--value first-letter-uppercase'}>{Utils.moneyForHuman(paymentVoucher.amount)} {lowerCase(currencyName)}</div>
                                        </div>
                                        <div className="detail-item">
                                            <div className={'detail-item--label'}>Kèm theo chứng từ gốc:</div>
                                            <div className={'detail-item--value'}/>
                                        </div>
                                    </Col>
                                    <Col span={10}>
                                        <div className="voucher-qr-code">
                                            <QrCode value={Utils.buildUrl(window.location, `/payment-vouchers/${this.getCode()}`)}  />
                                            <Barcode value={paymentVoucher.code} />
                                            <div className={'text-right barcode-text'}>{paymentVoucher.code}</div>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="voucher-signed mg-t-60">
                                    <div className="voucher-signed-column">
                                        <div className="bold">Giám đốc</div>
                                        <div>(Ký, họ tên, đóng dấu)</div>
                                    </div>
                                    <div className="voucher-signed-column">
                                        <div className="bold">Kế toán trưởng</div>
                                        <div>(Ký, họ tên)</div>
                                    </div>
                                    <div className="voucher-signed-column">
                                        <div className="bold">Người nhận tiền</div>
                                        <div>(Ký, họ tên)</div>
                                    </div>
                                    <div className="voucher-signed-column">
                                        <div className="bold">Người lập phiếu</div>
                                        <div className={'mg-bt-60'}>(Ký, họ tên)</div>
                                        <div
                                            className={'bold'}>{get(paymentVoucher, 'preparedBy.name')}
                                        </div>
                                        <div>({get(paymentVoucher, 'preparedBy.username')})</div>
                                    </div>
                                    <div className="voucher-signed-column">
                                        <div className="bold">Thủ quỹ</div>
                                        <div>(Ký, họ tên)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    }
}

export default PaymentVoucherPrint;
